window.addEventListener('load', () => {
    let availableCarousels = document.querySelectorAll('.splide');
    let gallerySplidePanel = document.querySelectorAll('.gallery-panel');
    let instagramSplidePanel = document.querySelectorAll('.instagram-panel')
    let cardSplidePanel = document.querySelectorAll('.card-panel.active-splide');
    let homeHeroSplidePanel = document.querySelectorAll('.home-image-header-panel');
    let eventSelectorPanel = document.querySelectorAll('.event-selector-panel');
    const cardPanel = document.querySelectorAll('.card-panel-slider');

    if (availableCarousels.length) {
        // START GALLERY PANEL SLIDER
        for ( let panel of gallerySplidePanel ) {
            let parentPanel = panel.closest('.gallery-panel');
            let galleryType = (parentPanel.classList.contains('gallery-panel-mosaic') ? 'mosaic' : 'slider');
            let galleryThumbnails = parentPanel.querySelectorAll('.gallery-panel-image');
            let lightbox = parentPanel.querySelector('.gallery-panel-lightbox');
            let lightboxBackdrop = (lightbox ? lightbox.querySelector('.lightbox-backdrop') : null);
            let lightboxClose = (lightbox ? lightbox.querySelector('.lightbox-close') : null);
            let progressBar = (lightbox ? lightbox.querySelector('.carousel-progress-bar') : null);

            const splideElement = panel.querySelector('.splide');
            if (!splideElement) {
                break;
            }

            if (galleryType === 'mosaic') {
                var lbox = new Splide(splideElement, {
                    type: 'fade',
                    classes: {
                        arrows: 'splide__arrows absolute w-full h-full flex items-center justify-between',
                        arrow: 'splide__arrow relative z-5 rounded-l-lg w-14 h-16 p-2 bg-rooftop-blue bg-opacity-20 md:bg-transparent md:p-0 md:w-10 md:h-12 fill-current text-white disabled:text-opacity-20 transition-all duration-300 flex items-center justify-center hover:scale-110 disabled:!scale-100',
                        prev: 'splide__arrow--prev left-0 md:left-[calc(-1.25rem_-_2.5vw)] 2xl:-left-16 rotate-180',
                        next: 'splide__arrow--next right-0 md:right-[calc(-1.25rem_-_2.5vw)] 2xl:-right-16',
                    },
                });
            }
            else {
                var main = new Splide(splideElement, {
                    type: 'fade',
                    pagination: false,
                    arrows: false,
                    cover: true,
                    autoplay: true,
                });
                const thumbnailSliderElement = panel.querySelector('.thumbnail-slider');
                if (!thumbnailSliderElement) {
                    break;
                }
                var thumbnails = new Splide(thumbnailSliderElement, {
                    rewind: true,
                    fixedWidth: 104,
                    fixedHeight: 104,
                    isNavigation: true,
                    arrows: false,
                    gap: 10,
                    focus: 'center',
                    pagination: false,
                    cover: true,
                    dragMinThreshold: {
                        mouse: 4,
                        touch: 10,
                    },
                    breakpoints: {
                        640: {
                            fixedWidth: 66,
                            fixedHeight: 66,
                        },
                    },
                });

            }

            function closeLightBox() {
                lightbox.classList.add('opacity-0');
                lightbox.classList.add('pointer-events-none');
                document.documentElement.classList.toggle('body-lock-scroll-modal');
                const lightboxHide = setTimeout(() => {
                    lightbox.classList.add('hidden');
                }, 300);
            }

            function openLightBox() {
                lightbox.classList.remove('hidden');
                document.documentElement.classList.toggle('body-lock-scroll-modal');
                const lightboxShow = setTimeout(() => {
                    lightbox.classList.remove('opacity-0');
                    lightbox.classList.remove('pointer-events-none');
                }, 50);
            }

            if (lightbox && galleryType === 'mosaic') {
                // Closes lightbox on backdrop/close button press

                lightboxBackdrop.addEventListener('click', () => {
                    closeLightBox();
                });

                lightboxClose.addEventListener('click', () => {
                    closeLightBox();
                });

                // Closes lightbox on key 'esc' press or navigates slider on keys 'arrowLeft' and 'arrowRight'

                document.addEventListener("keydown", (e) => {
                    if (!lightbox.classList.contains('hidden')) {
                        if (e.key === "Escape") {
                            closeLightBox();
                        }
                        else if (e.key === "ArrowRight") {
                            lbox.go('+1');
                        }
                        else if (e.key === "ArrowLeft") {
                            lbox.go('-1');
                        }
                    }
                });

                // Opens lightbox and navigates carousel to the thumbnail that was pressed

                for ( let thumbnail of galleryThumbnails ) {
                    thumbnail.addEventListener('click', () => {
                        if (thumbnail.dataset.slide.length) {
                            lbox.go(parseInt(thumbnail.dataset.slide));
                        }
                        openLightBox();
                    });
                }

                // Updates carousel progress bar width

                lbox.on('mounted move', function () {
                    let end = lbox.Components.Controller.getEnd() + 1;
                    progressBar.style.width = String(100 * (lbox.index + 1) / end) + '%';
                });
            }

            if (galleryType === 'slider') {

                let currentSrc = '';

                main.on('move', function () {
                    const updateBgImg = setTimeout(() => {
                        let mainSlider = parentPanel.querySelector('.main-slider');
                        let mainSliderPanelLoop = mainSlider.dataset.panelloop;
                        let mainSliderBgDiv = '.bg-gallery-slider-image-' + mainSliderPanelLoop.toString();
                        let safariSliderBgImg = '.bg-gallery-image-safari-backup-' + mainSliderPanelLoop.toString();
                        currentSrc = mainSlider.querySelector('.is-active').querySelector('img').currentSrc;
                        parentPanel.querySelector(mainSliderBgDiv).classList.add('!opacity-0');
                        parentPanel.querySelector(safariSliderBgImg).classList.add('!opacity-0');
                    }, 50);

                    const updateBgImgSrc = setTimeout(() => {
                        let mainSlider = parentPanel.querySelector('.main-slider');
                        let mainSliderPanelLoop = mainSlider.dataset.panelloop;
                        let mainSliderBgDiv = '.bg-gallery-slider-image-' + mainSliderPanelLoop.toString();
                        let safariSliderBgImg = '.bg-gallery-image-safari-backup-' + mainSliderPanelLoop.toString();
                        parentPanel.querySelector(mainSliderBgDiv).style.backgroundImage = "url(" + currentSrc + ")";
                        parentPanel.querySelector(safariSliderBgImg).style.backgroundImage = "url(" + currentSrc + ")";
                    }, 150);

                    const revealBg = setTimeout(() => {
                        let mainSlider = parentPanel.querySelector('.main-slider');
                        let mainSliderPanelLoop = mainSlider.dataset.panelloop;
                        let mainSliderBgDiv = '.bg-gallery-slider-image-' + mainSliderPanelLoop.toString();
                        let safariSliderBgImg = '.bg-gallery-image-safari-backup-' + mainSliderPanelLoop.toString();
                        parentPanel.querySelector(mainSliderBgDiv).classList.remove('!opacity-0');
                        parentPanel.querySelector(safariSliderBgImg).classList.remove('!opacity-0');
                    }, 350);

                });
            }

            if (galleryType === 'mosaic') {
                lbox.mount();
            }
            else {
                main.sync(thumbnails);
                main.mount();
                thumbnails?.mount();
            }
        }
        // END GALLERY PANEL SLIDER

        // START INSTAGRAM PANEL SLIDER
        for ( let panel of instagramSplidePanel ) {
            let parentPanel = panel.closest('.instagram-panel');
            let instagramThumbnails = parentPanel?.querySelectorAll('.instagram-panel-image');

            let lightbox = parentPanel?.querySelector('.instagram-panel-lightbox');
            let lightboxBackdrop = (lightbox ? lightbox.querySelector('.lightbox-backdrop') : null);
            let lightboxClose = (lightbox ? lightbox.querySelector('.lightbox-close') : null);

            let currentPostCounter = parentPanel?.querySelector('.card-splide-current-slide');

            let navArrows = parentPanel ? parentPanel.querySelectorAll('.splide-nav-arrow') : null;
            let instagramSliderSplide = parentPanel ? parentPanel.querySelector('.instagram-slider-splide') : null;
            let totalSlides = instagramSliderSplide ? instagramSliderSplide.dataset.totalSlides : 0;

            let progressBar = (lightbox ? lightbox.querySelector('.carousel-progress-bar') : null);

            const instagramSliderSplideElement = panel.querySelector('.instagram-slider-splide');
            const instagramLigthboxSplideElement = panel.querySelector('.instagram-lightbox-splide');
            if (!instagramSliderSplideElement || ! instagramLigthboxSplideElement) {
                break;
            }

            var instagramSplide = new Splide(instagramSliderSplideElement, {
                type: 'slide',
                perPage: 4,
                gap: '2rem',
                perMove: 1,
                arrows: true,
                padding: { left: '1rem', right: '1rem' },
                classes: {
                    arrows: 'splide__arrows absolute w-max h-max flex items-center justify-between flex top-[-3rem] lg:top-[-2rem] right-4 lg:right-[1.75rem] gap-4 1.5xl:right-[0.5rem]',
                    arrow: 'splide__arrow relative z-5 bg-transparent p-0 w-10 h-12 fill-current text-rooftop-blue disabled:text-opacity-20 transition-all duration-300 flex items-center justify-center hover:scale-110 disabled:!scale-100',
                    prev: 'splide__arrow--prev rotate-180',
                    next: 'splide__arrow--next',
                },
                breakpoints: {
                    1440: {
                        perPage: 3,
                        padding: { left: '2rem', right: '2rem' },
                        gap: '2rem'
                    },
                    1024: {
                        perPage: 2,
                        padding: { left: '2rem', right: '2rem' },
                        gap: '2rem'
                    },
                    640: {
                        perPage: 1,
                        padding: { left: '1rem', right: '1rem' },
                    },
                },
            });

            var instagramLightbox = new Splide(instagramLigthboxSplideElement, {
                type: 'fade',
                classes: {
                    arrows: 'splide__arrows absolute w-full h-full flex items-center justify-between',
                    arrow: 'splide__arrow relative z-5 rounded-l-lg bg-rooftop-blue bg-opacity-20 md:bg-transparent p-0 w-10 h-12 fill-current text-white disabled:text-opacity-20 transition-all duration-300 flex items-center justify-center hover:scale-110 disabled:!scale-100',
                    prev: 'splide__arrow--prev left-[calc(-1.25rem_-_2.5vw)] 2xl:-left-16 rotate-180',
                    next: 'splide__arrow--next right-[calc(-1.25rem_-_2.5vw)] 2xl:-right-16',
                },
            });

            for ( let arrow of navArrows ) {
                arrow.addEventListener('click', () => {
                    if (arrow.dataset.navigate == '+') {
                        cardSplide.go('+1');
                    }
                    else {
                        cardSplide.go('-1');
                    }
                });
            }

            function closeLightBox() {
                lightbox.classList.add('opacity-0');
                lightbox.classList.add('pointer-events-none');
                document.documentElement.classList.toggle('body-lock-scroll-modal');
                const lightboxHide = setTimeout(() => {
                    lightbox.classList.add('hidden');
                }, 300);
            }

            function openLightBox() {
                lightbox.classList.remove('hidden');
                document.documentElement.classList.toggle('body-lock-scroll-modal');
                const lightboxShow = setTimeout(() => {
                    lightbox.classList.remove('opacity-0');
                    lightbox.classList.remove('pointer-events-none');
                }, 50);
            }

            for ( let thumbnail of instagramThumbnails ) {
                thumbnail.addEventListener('click', () => {
                    if (thumbnail.dataset.slide.length) {
                        instagramLightbox.go(parseInt(thumbnail.dataset.slide));
                    }
                    openLightBox();
                });
            }

            if (lightbox) {
                // Closes lightbox on backdrop/close button press

                document.addEventListener("keydown", (e) => {
                    if (!lightbox.classList.contains('hidden')) {
                        if (e.key === "Escape") {
                            closeLightBox();
                        }
                        else if (e.key === "ArrowRight") {
                            instagramLightbox.go('+1');
                        }
                        else if (e.key === "ArrowLeft") {
                            instagramLightbox.go('-1');
                        }
                    }
                });

                instagramLightbox.on('mounted move', function () {
                    let end = instagramLightbox.Components.Controller.getEnd() + 1;
                    progressBar.style.width = String(100 * (instagramLightbox.index + 1) / end) + '%';
                });

                lightboxBackdrop.addEventListener('click', () => {
                    closeLightBox();
                });

                lightboxClose.addEventListener('click', () => {
                    closeLightBox();
                });
            }

            instagramSplide.on('mounted move', function () {
                if (currentPostCounter) {
                    const updateIndex = setTimeout(() => {
                        currentPostCounter.textContent = (instagramSplide.index + 1).toString();
                        for ( let arrow of navArrows ) {
                            if (arrow.dataset.navigate == '+' && (instagramSplide.index + 1) == totalSlides) {
                                arrow.classList.add('!opacity-20');
                            }
                            else if (arrow.dataset.navigate == '+') {
                                arrow.classList.remove('!opacity-20');
                            }

                            if (arrow.dataset.navigate == '-' && (instagramSplide.index + 1) == 1) {
                                arrow.classList.add('!opacity-20');
                            }
                            else if (arrow.dataset.navigate == '-') {
                                arrow.classList.remove('!opacity-20');
                            }
                        }
                    }, 50);
                }
            });

            instagramSplide.sync(instagramLightbox);
            instagramSplide.mount();
            instagramLightbox.mount();
        }
        // END INSTAGRAM PANEL SLIDER

        // START CARD PANEL SLIDER
        for ( let panel of cardSplidePanel ) {
            let parentPanel = panel.closest('.card-panel');
            let currentCardCounter = parentPanel.querySelector('.card-splide-current-slide');
            let navArrows = parentPanel.querySelectorAll('.splide-nav-arrow');
            let totalSlides = parentPanel.querySelector('.splide').dataset.totalSlides;

            const splideElement = panel.querySelector('.splide');
            if (!splideElement) {
                break;
            }

            var cardSplide = new Splide(splideElement, {
                type: 'slide',
                perPage: 3,
                gap: '2rem',
                perMove: 1,
                arrows: true,
                padding: { left: '1rem', right: '1rem' },
                classes: {
                    arrows: 'splide__arrows absolute w-max h-max flex items-center justify-between hidden sm:flex top-[-4.5rem] right-4 lg:right-8 1.5xl:right-4 gap-4',
                    arrow: 'splide__arrow relative z-5 bg-transparent p-0 w-10 h-12 fill-current text-rooftop-blue disabled:text-opacity-20 transition-all duration-300 flex items-center justify-center hover:scale-110 disabled:!scale-100',
                    prev: 'splide__arrow--prev rotate-180',
                    next: 'splide__arrow--next',
                },
                breakpoints: {
                    1439: {
                        perPage: 3,
                        padding: { left: '2rem', right: '2rem' },
                    },
                    1023: {
                        perPage: 2,
                        padding: { left: '1.5rem', right: '1.5rem' },
                    },
                    639: {
                        perPage: 1,
                        padding: { left: '1rem', right: '1rem' },
                    },
                },
            });

            for ( let arrow of navArrows ) {
                arrow.addEventListener('click', () => {
                    if (arrow.dataset.navigate == '+') {
                        cardSplide.go('+1');
                    }
                    else {
                        cardSplide.go('-1');
                    }
                });
            }

            cardSplide.on('mounted move', function () {
                if (currentCardCounter) {
                    const updateIndex = setTimeout(() => {
                        currentCardCounter.textContent = (cardSplide.index + 1).toString();
                        for ( let arrow of navArrows ) {
                            if (arrow.dataset.navigate == '+' && (cardSplide.index + 1) == totalSlides) {
                                arrow.classList.add('!opacity-20');
                            }
                            else if (arrow.dataset.navigate == '+') {
                                arrow.classList.remove('!opacity-20');
                            }

                            if (arrow.dataset.navigate == '-' && (cardSplide.index + 1) == 1) {
                                arrow.classList.add('!opacity-20');
                            }
                            else if (arrow.dataset.navigate == '-') {
                                arrow.classList.remove('!opacity-20');
                            }
                        }
                    }, 50);
                }
            });

            cardSplide.mount();
        }
        // END CARD PANEL SLIDER

        // START HOME MOVIE CARD SLIDER
        for ( let panel of homeHeroSplidePanel ) {
            let parentPanel = panel.closest('.home-image-header-panel');
            let currentCardCounter = parentPanel.querySelector('.card-splide-current-slide');
            let navArrows = parentPanel.querySelectorAll('.splide-nav-arrow');
            let splideSlider = parentPanel.querySelector('.splide');

            if (splideSlider) {
                let totalSlides = parentPanel.querySelector('.splide').dataset.totalSlides;

                const splideElement = panel.querySelector('.splide');
                if (!splideElement) {
                    break;
                }

                var homeHeroSplide = new Splide(splideElement, {
                    type: 'slide',
                    perPage: 3,
                    gap: '2rem',
                    perMove: 1,
                    arrows: false,
                    drag: false,
                    padding: { left: '1rem', right: '1rem' },
                    classes: {
                        arrows: 'splide__arrows absolute w-max h-max flex items-center justify-between hidden sm:flex top-[-4.5rem] right-4 lg:right-8 1.5xl:right-4 gap-4',
                        arrow: 'splide__arrow relative z-5 bg-transparent p-0 w-10 h-12 fill-current text-white disabled:text-opacity-20 transition-all duration-300 flex items-center justify-center hover:scale-110 disabled:!scale-100',
                        prev: 'splide__arrow--prev rotate-180',
                        next: 'splide__arrow--next',
                    },
                    breakpoints: {
                        1439: {
                            perPage: 3,
                            padding: { left: '2rem', right: '2rem' },
                        },
                        1023: {
                            arrows: true,
                            drag: true,
                            perPage: 2,
                            padding: { left: '1.5rem', right: '1.5rem' },
                        },
                        639: {
                            arrows: true,
                            drag: true,
                            perPage: 1,
                            padding: { left: '1.5rem', right: '1.5rem' },
                        },
                    },
                });

                for ( let arrow of navArrows ) {
                    arrow.addEventListener('click', () => {
                        if (arrow.dataset.navigate == '+') {
                            homeHeroSplide.go('+1');
                        }
                        else {
                            homeHeroSplide.go('-1');
                        }
                    });
                }

                homeHeroSplide.on('mounted move', function () {
                    if (currentCardCounter) {
                        const updateIndex = setTimeout(() => {
                            currentCardCounter.textContent = (homeHeroSplide.index + 1).toString();
                            for ( let arrow of navArrows ) {
                                if (arrow.dataset.navigate == '+' && (homeHeroSplide.index + 1) == totalSlides) {
                                    arrow.classList.add('!opacity-20');
                                }
                                else if (arrow.dataset.navigate == '+') {
                                    arrow.classList.remove('!opacity-20');
                                }

                                if (arrow.dataset.navigate == '-' && (homeHeroSplide.index + 1) == 1) {
                                    arrow.classList.add('!opacity-20');
                                }
                                else if (arrow.dataset.navigate == '-') {
                                    arrow.classList.remove('!opacity-20');
                                }
                            }
                        }, 50);
                    }
                });

                homeHeroSplide.mount();
            }
        }
        // END HOME MOVIE CARD SLIDER

        // START DATE SELECTOR SLIDER
        if (eventSelectorPanel.length) {
            let elementIndex = 0;
            if (window.location.hash.length > 1) {
                const performanceRef = window.location.hash.substring(1);
                const performanceSplide = document.querySelector(`li.splide__slide[data-performance="${performanceRef}"]`);

                if (performanceSplide) {
                    const siblings = [...performanceSplide.parentElement.children];
                    elementIndex = siblings.indexOf(performanceSplide);
                }
            }

            for ( let panel of eventSelectorPanel ) {
                let parentPanel = panel.closest('.event-selector-panel');

                const splideDateSelectorElement = panel.querySelector('.splide-date-selector');
                if (!splideDateSelectorElement) {
                    break;
                }

                let dateSelectorSplide = new Splide(splideDateSelectorElement, {
                    start: elementIndex,
                    type: 'slide',
                    gap: '1rem',
                    autoWidth: 'true',
                    pagination: false,
                    perMove: 1,
                    arrows: true,
                    updateOnMove: true,
                    padding: { left: '1rem', right: '1rem' },
                    classes: {
                        arrows: 'splide__arrows relative w-[6rem] h-max flex items-center justify-between flex gap-4',
                        arrow: 'splide__arrow relative z-5 bg-rooftop-blue rounded-full p-3 w-10 h-10 fill-current text-rooftop-yellow disabled:bg-opacity-20 transition-all duration-300 flex items-center justify-center hover:scale-110 disabled:!scale-100',
                        prev: 'splide__arrow--prev rotate-180',
                        next: 'splide__arrow--next',
                    },
                });

                dateSelectorSplide.mount();

                const dateSelectors = parentPanel.querySelectorAll('button[data-ticketing][data-date]');
                const performanceAccordions = parentPanel.querySelectorAll('div.performance-cards > div');
                let nextButtons = parentPanel.querySelectorAll('.splide__arrow--next');
                let prevButtons = parentPanel.querySelectorAll('.splide__arrow--prev');
                let slideButtons = parentPanel.querySelectorAll('.splide__slide');

                for ( let button of slideButtons ) {
                    button.addEventListener('click', (event) => {
                        dateSelectorSplide.go(parseInt(button.getAttribute('data-loopindex')));
                    });
                }

                function showHideDates() {
                    for ( let dateSelector of dateSelectors ) {
                        dateSelector.classList.remove('selected');
                        dateSelector.ariaSelected = 'false';
                    }

                    setTimeout(() => {
                        let newActive = panel.querySelector('.splide__slide.is-active > button');
                        if (newActive) {
                            newActive.classList.add('selected');
                            newActive.ariaSelected = 'true';

                            const selectedDate = newActive.getAttribute('data-date');
                            const datePerformanceCount = [...performanceAccordions].filter((performanceAccordion) => performanceAccordion.querySelector('button[data-date]').getAttribute('data-date') === selectedDate).length;

                            performanceAccordions.forEach((performanceAccordion) => {
                                const performanceCard = performanceAccordion.querySelector('button[data-date]');
                                const accordionContent = performanceAccordion.querySelector('.accordion-content');

                                if (performanceCard.getAttribute('data-date') === selectedDate) {
                                    performanceAccordion.classList.remove('hidden');
                                    performanceCard.classList.remove('hidden');

                                    const displayPricebands = datePerformanceCount > 1;
                                    if (!displayPricebands && accordionContent) {
                                        accordionContent.classList.remove('!max-h-[0]', 'hidden', 'opacity-0');
                                    }
                                }
                                else {
                                    performanceAccordion.classList.add('hidden');
                                    performanceCard.classList.add('hidden');
                                    if (accordionContent) {
                                        accordionContent.classList.add('!max-h-[0]', 'hidden', 'opacity-0');
                                    }
                                }
                            });
                        }
                    }, 50);
                }

                showHideDates();

                for ( let button of nextButtons ) {
                    button.addEventListener('click', (event) => {
                        showHideDates();
                    });
                }


                for ( let button of prevButtons ) {
                    button.addEventListener('click', (event) => {
                        showHideDates();
                    });
                }
            }
        }
        // END DATE SELECTOR SLIDER

        // START CARD PANEL SLIDER
        for ( const panel of cardPanel ) {
            const totalSlides = parseInt(panel.querySelector('.card-panel-splide').dataset.totalSlides);
            const paginationColor = panel.querySelector('.card-panel-splide').dataset.paginationColor;
            const paginationBorderColor = panel.querySelector('.card-panel-splide').dataset.paginationBorderColor;
            const arrowColor = panel.querySelector('.card-panel-splide').dataset.arrowColor;

            const cardPanelSplideElement = panel.querySelector('.card-panel-splide');
            if (!cardPanelSplideElement) {
                break;
            }

            const cardSplide = new Splide(cardPanelSplideElement, {
                type: 'slide',
                speed: 750,
                direction: 'ltr',
                pauseOnHover: true,
                arrows: true,
                perPage: 3,
                pagination: true,
                autoplay: false,
                gap: '2rem',
                padding: '2rem',
                interval: 10000,
                destroy: totalSlides <= 3,
                classes: {
                    pagination: 'splide__pagination flex justify-center items-center gap-2 w-max !mx-auto pb-2 sm:!mr-6 sm:!mr-8',
                    page: 'splide__pagination__page rounded-full overflow-hidden w-3 h-3 opacity-50 hover:scale-105 [&.is-active]:opacity-100 transition-all duration-150 ease-in-out border' + ' ' + paginationColor + ' ' + paginationBorderColor,
                    arrows: 'splide__arrows absolute w-full sm:w-max h-max px-4 sm:px-0 flex items-center justify-between flex bottom-0 left-0 sm:bottom-[unset] sm:left-[unset] sm:top-2 lg:top-0 sm:right-6 lg:right-8 gap-4',
                    arrow: 'splide__arrow relative z-5 bg-transparent p-0 w-10 h-12 fill-current disabled:text-opacity-20 transition-all duration-300 flex items-center justify-center hover:scale-110 active:!duration-75 active:!scale-125 disabled:!scale-100' + ' ' + arrowColor,
                    prev: 'splide__arrow--prev rotate-180',
                    next: 'splide__arrow--next',
                },
                breakpoints: {
                    1023: {
                        perPage: 2,
                        padding: '1.5rem',
                        gap: '1.5rem',
                        destroy: totalSlides <= 2,
                    },
                    767: {
                        perPage: 1,
                        padding: '1.5rem',
                        gap: '1.5rem',
                        destroy: totalSlides === 1,
                    },
                    639: {
                        perPage: 1,
                        padding: '1rem',
                        gap: '1.5rem',
                        destroy: totalSlides === 1,
                    },
                },
            });

            cardSplide.mount();
        }
        // END CARD PANEL SLIDER
    }
});
